import { gql } from '@apollo/client'

export const CREATE_GUEST_CARD = gql`
  mutation CreateGuestCard($payload: CreateGuestCardPayload, $personId: Int) {
    createGuestCard(payload: $payload, person_id: $personId) {
      id
      status
      received_at
      last_activity_type
      max_rent
      monthly_income
    }
  }
`
